
/**
 * @file ScanReceiptButton.tsx
 * @description Button component for triggering the receipt scanner.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !! WARNING: This file is considered feature-complete and should not be modified unless absolutely !!
 * !! necessary. Any changes may disrupt the stable functionality of the receipt scanning feature.  !!
 * !! If changes are required, please consult with the team and thoroughly test all functionality.  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { Camera, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ScanReceiptButtonProps {
  onClick: () => void;
}

export const ScanReceiptButton: React.FC<ScanReceiptButtonProps> = ({
  onClick
}) => {
  const { t } = useTranslation();
  
  return (
    <Button 
      onClick={onClick} 
      variant="outline" 
      className="w-full bg-white/50 dark:bg-black/50 border-dashed text-gray-700 dark:text-gray-300"
    >
      <Camera className="h-4 w-4" />
      <span className="flex items-center gap-1">
        {t('expenses.scanReceipt')}
        <Sparkles className="h-3 w-3 text-amber-500" />
      </span>
    </Button>
  );
};
